<!-- <app-hotel-booking-steps [rooms]="true" [guests]="true" [payment]="true" [confirmation]="true">
</app-hotel-booking-steps> -->
<div class="container nopad">
    <div class="card my-2" *ngIf=" bookingDetails">
        <div class="card-body pb-3">

            <div class="row mobile_row">
                <div class="col-md-12 col-lg-12">
                    <h5>Thanks {{leadPax?.FirstName}} {{leadPax?.LastName}}</h5>
                    <h3 class="font-weight-bold">Your booking in {{bookingDetails.HotelName}} is confirmed.</h3>
                    <span style="font-size: 16px; color: #000;">For your reference, your Booking ID is
                        <span class="cusromBlue">{{bookingDetails.AppReference}} /
                            {{bookingDetails.ConfirmationReference}}</span>
                    </span>
                    <ul class="list-unstyled mt-4" style="font-size: initial;">
                        <li>
                            <i class="fa fa-check" aria-hidden="true"></i>&nbsp;
                            We've sent your confirmation email to
                            <strong>{{leadPax.Email}} </strong>
                        </li>
                        <li>
                            <i class="fa fa-check" aria-hidden="true"></i>&nbsp;
                            <strong>{{bookingDetails.HotelName}}</strong> is
                            expecting you on
                            <span class="bigdate_book">{{bookingDetails.HotelCheckIn | date: 'dd MMM yyyy'}}</span>
                        </li>
                        <!-- <li>
                            <i class="fa fa-check" aria-hidden="true"></i>&nbsp;
                            You can now
                            <a href="javascript:void(0);" class="custom_track"> modify </a> or
                            <a routerlinkactive="router-link-active" class="custom_track"
                                href="/b2c/hotel/hotel-cancellation?AppReference=HB511-1612435-993511"> cancel
                            </a>
                            your booking until check-in.
                        </li> -->
                        <li>
                            <i class="fa fa-check" aria-hidden="true"></i>&nbsp;
                            Your <strong>payment</strong> will be handled
                            by <strong> {{bookingDetails.HotelName}} </strong>.
                            The <strong>Payment </strong>section below has more
                            details.
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="container nopad">
    <div class="row mobile_row" *ngIf="bookingDetails">
        <div class="col-md-8 col-lg-8">
            <div class="card mb-2 mt-2">
                <section style="background-color: #189ad3;color: white;">
                    <h5 class="p-2 m-0">Hotel Details</h5>
                </section>
                <div class="card-body pb-3">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12" style="text-align: left;">
                                <h5 class="cusromGrey"><strong>
                                        {{bookingDetails.HotelName}}
                                    </strong> </h5>
                                <i class="fa fa-phone" aria-hidden="true"></i>&nbsp;{{bookingDetails.PhoneNumber}}
                                <br>
                                <p class="cusromGrey">
                                    <i class="fa fa-map-marker cusromGrey" aria-hidden="true"></i>
                                    &nbsp;
                                    {{bookingDetails.HotelAddress}}
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="font-weight-bold cusromBlue">
                                    <i class="fa fa-calendar" aria-hidden="true"></i>&nbsp;Check-In
                                </div>
                                {{bookingDetails.HotelCheckIn | date: 'fullDate'}}
                            </div>
                            <div class="col-md-6">
                                <div class="font-weight-bold cusromBlue"><i class="fa fa-calendar"
                                        aria-hidden="true"></i>&nbsp;Check-Out</div>
                                {{bookingDetails.HotelCheckOut | date: 'fullDate'}}
                            </div>
                        </div>
                        <div class="row pt-2">
                            <div class="col-md-12">
                                <p class="font-weight-bold">Total No. of Nights - {{nights}}</p>
                            </div>
                            <ng-container *ngFor="let room of roomDetails">
                                <div class="col-md-12 font-weight-bold">
                                    <span class="">
                                        1&nbsp;<i class="fa fa-times"></i>&nbsp;{{room.RoomTypeName}}
                                    </span>
                                </div>
                                <!-- <div class="col-md-12">
                                    <span class="col-6 font-weight-bold pl-0">
                                        {{"Cancellation Policy "}} -->
                                        <!-- Free Cancellation Available -->
                                    <!-- </span>
                                    <span class="col-6 font-weight-normal"> -->

                                        <!-- {{'Free Cancellation Available'}} -->
                                        <!-- <span [innerHTML]="getCancelationPolicy(bookingDetails['CancellationPolicy'])">
                                        </span> -->
                                        <!-- <span [innerHTML]="getCancelationPolicy(bookingDetails['CancellationPolicy'])"> </span> -->
                                    <!-- </span>
                                </div> -->
                            </ng-container>
                            <div class="col-md-12">
                                <p>
                                    <span class="font-weight-bold">
                                        {{'Remarks'}}
                                    </span>
                                    <span class="">
                                        {{bookingDetails.Remarks}}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <button class="btn btn-lg btn-primary" (click)="goToVoucher(bookingDetails.AppReference)">
                            Print Confirmation
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-lg-4 pl-0 mpad">
            <div class="card mb-2 mt-2">
                <section style="background-color: #189ad3;color: white;">
                    <h5 class="p-2 m-0">Payment Details</h5>
                </section>
                <div class="card-body pb-3">
                    <table class="table">
                        <tbody>
                            <tr>
                                <th class="cusromBlue">Total</th>
                                <th class="text-right">
                                    {{bookingDetails.Currency}} {{totalFare}}
                                </th>
                            </tr>
                            <tr>
                                <th class="cusromBlue">Convenience Fees</th>
                                <th class="text-right">
                                    {{bookingDetails.Currency}} 0
                                </th>
                            </tr>
                            <tr>
                                <th class="cusromBlue">Taxes & Fees</th>
                                <th class="text-right">
                                    {{bookingDetails.Currency}} 0
                                </th>
                            </tr>
                            <tr>
                                <th class="cusromBlue">Discount</th>
                                <th class="text-right">
                                    {{bookingDetails.Currency}} 0
                                </th>
                            </tr>
                            <tr>
                                <th class="cusromBlue" style="font-size: large;">Amount Payable</th>
                                <th class="text-right">
                                    <h4 class="font-weight-bold">
                                        {{bookingDetails.Currency}} {{totalFare}}
                                    </h4>
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-loading [show]="loading"
    [config]="{primaryColour: primaryColour, secondaryColour: secondaryColour, tertiaryColour: primaryColour, backdropBorderRadius: '3px',fullScreenBackdrop:true}"
    [template]="loadingTemplate"></ngx-loading>
    